/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Command_HintInputs */

const en_directory_agents_command_hint = /** @type {(inputs: Directory_Agents_Command_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste this into Codex, Claude Code, Cursor, or any agent once your product is deployed.`)
};

const zh_directory_agents_command_hint = /** @type {(inputs: Directory_Agents_Command_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品部署完成后，把这行话粘贴给 Codex、Claude Code、Cursor 或任何 agent。`)
};

/**
* | output |
* | --- |
* | "Paste this into Codex, Claude Code, Cursor, or any agent once your product is deployed." |
*
* @param {Directory_Agents_Command_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_command_hint = /** @type {((inputs?: Directory_Agents_Command_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Command_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_command_hint(inputs)
	return zh_directory_agents_command_hint(inputs)
});
export { directory_agents_command_hint as "directory.agents.command_hint" }